import { Component } from '@angular/core';

@Component({
  selector: 'last-reels-ig',
  templateUrl: './last-reels-ig.component.html',
  styleUrls: ['./last-reels-ig.component.css']
})
export class LastReelsIgComponent {
  facebookHovered = false;
  instagramHovered = false;

  openInstagram() {
    window.open('https://www.instagram.com/dramcapital/');
  }
  openFacebook() {
    window.open('https://www.facebook.com/DramCapital');
  }
}
